import { VerticalView } from './vertical-view';
/**
 * work week view
 */
export class WorkWeek extends VerticalView {
    /**
     * Constructor for work week view
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    constructor(parent) {
        super(parent);
        this.viewClass = 'e-work-week-view';
    }
    startDate() {
        return this.getViewStartDate();
    }
    endDate() {
        return this.getViewEndDate();
    }
    /**
     * Get module name.
     *
     * @returns {string} Returns the module name.
     */
    getModuleName() {
        return 'workWeek';
    }
}
